import React from "react"
import { useMainOfficeNumber } from "hooks/useMainOfficeNumber"
import { Content } from "components/content/Content"
import type { ServiceElements } from "./service-types"
import type { ButtonElements } from "_types/Button"
import { ButtonParser } from "components/button/ButtonParser"
import "./service.module.scss"

interface ServiceProps {
  index: number
  serviceCount?: number
  serviceInfo: ServiceElements
}

export const Service = ({
  index,
  serviceCount = 0,
  serviceInfo,
}: ServiceProps) => {
  const {
    anchor_reference,
    associated_page,
    button_text,
    custom_anchor_reference,
    id,
    migrated_associated_page,
    name,
    price,
    service_features,
  } = serviceInfo

  const anchorReference = custom_anchor_reference || anchor_reference
  const hasAnchorReference = !!anchorReference

  const button: ButtonElements = {
    associated_page,
    button_text,
    anchor_reference,
    custom_anchor_reference,
    migrated_associated_page,
    button_style: hasAnchorReference ? "cta button" : "navigation button",
    custom_call_tracking_number: null,
    external_link: null,
    id: `${id}-${index}`,
    use_main_office_call_tracking_number: false,
  }

  const { mainOfficeNumber } = useMainOfficeNumber({})
  return (
    <div
      className={
        serviceCount >= 3 && index === 1
          ? `service service--most-popular`
          : `service`
      }
    >
      {name && (
        <div className="service__header">
          <h3>{name}</h3>
        </div>
      )}
      {service_features &&
        service_features.data?.service_features !== "<p><br></p>" && (
          <div className="service__body">
            <Content content={service_features.data?.service_features} />
          </div>
        )}
      <div
        className={
          index === 1
            ? `service__footer service__footer--primary`
            : `service__footer `
        }
      >
        {price && <p>{price}</p>}

        {button_text && (
          <div className="content-block-buttons">
            <ButtonParser
              buttons={[button]}
              ctaColorVariantOutline="outline-ghost"
              navigationColorVariantOutline="outline-ghost"
              isSingleCTAButtonAlwaysOutline
              isSingleNavButtonAlwaysOutline
            />
          </div>
        )}

        {mainOfficeNumber && (
          <div className="service__alternate-cta">
            Or Call:{" "}
            <a href={`tel:${mainOfficeNumber}`} className="service__phone">
              {mainOfficeNumber}
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
